module.exports = __webpack_public_path__ + "static/media/Section1_Stability.decea096.svg";